import { Box, Heading, Text, VStack } from '@chakra-ui/react'
import Carousel from './Carousel'
import ClassDisplay from './ClassDisplay'
import ButtonContactForm from './ButtonContactForm'
import Footer from './Footer'
import { IndividualLesson } from './ScheduleTable'
import { useTranslation } from 'react-i18next'

type CourseDetailLayoutProps = {
  title: string;
  images: string[];
  desktopImages?: string[];
  content: string[];
  classes: IndividualLesson[];
}

const CourseDetailLayout = ({ title, images, desktopImages, content, classes }: CourseDetailLayoutProps) => {
  const { t } = useTranslation()

  return (
  <>
    <Box bg="white">
      <Box
        width="100%"
        maxWidth="1200px"
        margin="0 auto"
        padding={{ base: '11vh 0 8vh', md: '13vh 0 10vh' }}
      >
        <Box
          width={{ base: '92vw', md: '86vw' }}
          maxWidth="1050px"
          margin="0 auto"
          overflow="hidden"
          borderRadius={{ base: '14px', md: '20px' }}
          boxShadow="0 8px 30px rgba(75, 55, 90, 0.12)"
        >
          <Carousel
            images={images}
            desktopImages={desktopImages}
            height={{ base: '58vh', md: '48vh' }}
            objectPosition={{ base: 'center top', md: 'center center' }}
          />
        </Box>

        <Heading
          as="h1"
          fontSize={{ base: '3xl', md: '5xl' }}
          color="gray.800"
          textAlign="center"
          marginTop={{ base: 8, md: 12 }}
          marginBottom={{ base: 6, md: 8 }}
        >
          {title}
        </Heading>

        <VStack
          width={{ base: '88vw', md: '72vw' }}
          maxWidth="820px"
          margin="0 auto"
          align="center"
          textAlign="center"
          spacing={5}
        >
          {content.map((paragraph, index) => (
            <Text
              key={index}
              fontSize={{ base: 'lg', md: 'xl' }}
              lineHeight="1.7"
              color="gray.700"
            >
              {paragraph}
            </Text>
          ))}
        </VStack>

        <Box
          width={{ base: '92vw', md: '78vw' }}
          maxWidth="900px"
          margin="12vh auto 0"
        >
          <Text
            fontSize={{ base: '2xl', md: '3xl' }}
            fontWeight="bold"
            color="gray.800"
            textAlign="center"
            marginBottom={6}
          >
            {t('courses.available')}
          </Text>
          <VStack align="stretch" spacing={4}>
            {classes.map((classItem, index) => (
              <ClassDisplay
                title={classItem.title}
                time={classItem.time}
                key={index}
              />
            ))}
          </VStack>
          <Box display="flex" justifyContent="center">
            <ButtonContactForm />
          </Box>
        </Box>
      </Box>
    </Box>
    <Footer />
  </>
)
}

export default CourseDetailLayout
